import { Box, Container, Typography } from "@mui/material";
import React from "react";
import CustomButton from "../CustomButton";
import {
  BarChartTwoTone,
  BookTwoTone,
  ChevronRightRounded,
  EmojiPeopleTwoTone,
  LightbulbTwoTone,
  MoodTwoTone,
  PeopleTwoTone,
  Star,
  VisibilityTwoTone,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const OurStorySection = () => {
  const navigate = useNavigate();
  const challenges = [
    {
      id: 1,
      problem: "The world's fastest growing population",
      icon: <PeopleTwoTone sx={{ color: "white" }} />,
    },
    {
      id: 2,
      problem:
        "The largest projected population of 1 billion children and youth by 2050",
      icon: <BarChartTwoTone sx={{ color: "white" }} />,
    },
    {
      id: 3,
      problem:
        "9 out of 10 children in sub-Saharan Africa can’t read or understand a simple text by the age of 10",
      icon: <BookTwoTone sx={{ color: "white" }} />,
    },
    {
      id: 4,
      problem:
        "80% of brain development in children occurs before the age of 3",
      icon: <LightbulbTwoTone sx={{ color: "white" }} />,
    },
  ];

  return (
    <Box sx={{ width: "100vw", mb: { xs: "3rem" } }}>
      {/* Our story section */}
      <Container
        sx={{
          height: { md: "70vh" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            mb: { xs: 3 },
          }}
        >
          <Typography variant="h7" sx={{ mb: "1rem" }}>
            Our Challenges
          </Typography>
          <Typography variant="h2" sx={{ width: "90%", mb: "1rem" }}>
            The <span style={{ color: "#DB5430" }}>challenges</span> we are{" "}
            <span style={{ color: "#DB5430" }}>addressing</span>
          </Typography>
          <i></i>
          <Typography>
            Across Africa, nations are not prepared for the imminent demand that
            will be placed on their education systems, and nations already face
            the challenges of insufficient schools, trained teachers, and
            quality resources (World Bank Group). Quality education is also more
            than what teacher say, what grades are scored and what knowledge is
            rote learned in a classroom setting. Education is the formal start
            to a lifelong journey of learning and growing socially, emotionally,
            physically, cognitively, and spiritually. If the lack of sufficient
            high-quality education opportunities is not addressed, Africa will
            not only have the issue of a largely illiterate generation but will
            also face widespread social and economic ramifications.
          </Typography>
          <Box>
            <CustomButton
              sx={{ my: "1rem" }}
              onClick={() => navigate("/donate")}
            >
              <Typography>Journey with us</Typography>
              <ChevronRightRounded />
            </CustomButton>
          </Box>
        </Box>
        <Box
          sx={{
            width: { xs: "100%", md: "45%" },
            height: { xs: "50vh", md: "80%" },
            /* backgroundColor: "#222222", */
            borderRadius: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: 2,
          }}
        >
          {challenges.map((challenge) => (
            <Box
              key={challenge.id}
              sx={{
                bgcolor: "whitesmoke",
                height: { md: 70 },
                width: "100%",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 2,
                p: 1,
                borderRadius: 3,
              }}
            >
              <Box sx={{ width: { xs: "20%", md: "10%" } }}>
                <Box
                  sx={{
                    display: "flex",
                    bgcolor: "primary.main",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    width: 50,
                    borderRadius: 100,
                    boxShadow: 5,
                  }}
                >
                  {challenge.icon}
                </Box>
              </Box>
              <Typography width={"100%"}>{challenge.problem}</Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default OurStorySection;
